import { render, staticRenderFns } from "./ProofreadingEditor.vue?vue&type=template&id=827a3426&scoped=true"
import script from "./ProofreadingEditor.vue?vue&type=script&lang=ts"
export * from "./ProofreadingEditor.vue?vue&type=script&lang=ts"
import style0 from "./ProofreadingEditor.vue?vue&type=style&index=0&id=827a3426&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827a3426",
  null
  
)

export default component.exports